<template>
  <div>


    <!-- <Header /> -->

      <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />
      <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
      <CoordinateHeader
        v-if="this.userInfo.user.permission == 'co-ordinator'"
      />
      <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />

    <div class="w-full h-full p-5 lg:p-10 flex flex-col gap-5">
      <div class="w-full flex justify-between items-center">
        <h1 class="text-lg lg:text-2xl font-semibold dark_text">
          Attendance List
        </h1>
        <div class="flex flex-col gap-1">
          <p>Date : {{ current_date }}</p>
          <p>Day : {{ current_day }}</p>
        </div>
      </div>
      <div v-if="loading" class="flex items-center justify-center">
        <img src="@/assets/attendance/loading.gif" alt="" />
      </div>
      <div v-else class="w-full overflow-scroll">
        <table
          class="min-w-full border-collapse"
          v-if="attendance_list.length > 0"
        >
          <thead>
            <tr class="bg-[#18469d] text whitespace-nowrap text-sm">
              <th class="px-6 py-3">Date</th>
              <!-- <th class="px-6 py-3">8.30AM - 9.25AM</th>
              <th class="px-6 py-3">9.25AM - 10.20AM</th>
              <th class="px-6 py-3">10.40AM - 11.35AM</th>
              <th class="px-6 py-3">11.35AM - 12.30PM</th>
              <th class="px-6 py-3">1.10PM - 2.05PM</th>
              <th class="px-6 py-3">2.05PM - 3.00PM</th>
              <th class="px-6 py-3">3.00PM - 3.55Pm</th> -->
              <th
                v-if="attendance_list.length && attendance_list[0].details"
                class="px-6 py-3"
                v-for="(detail, index) in this.attendance_list[0].details"
                :key="index"
              >
                {{ detail.session }}
              </th>
            </tr>
          </thead>
          <tbody v-if="attendance_list.length > 0">
            <tr
              v-for="list in attendance_list"
              :key="list"
              class="border border-[#afdaec] text-center whitespace-nowrap text-sm"
            >
              <td class="px-6 py-3 border border-gray-200">
                {{ list.date.split("-").reverse().join("-") }}
              </td>

              <td
                v-for="detail in list.details"
                :key="detail"
                class="px-6 py-3 border border-gray-200"
                :class="{
                  'bg-green-200': detail.class_status === '(T)',
                  'bg-red-300': detail.class_status === '(O)',
                  'bg-blue-300': detail.class_status === 'RA',
                  'bg-[#FFFFFF]': detail.class_status === '-',
                  'bg-[#FFFFFF]': detail.class_status === '(F)',
                  'bg-[#FFFFFF]': detail.class_status === '(Upcoming)',
                  'bg-green-500': detail.class_status === '(On Going)',
                  'bg-[#e5e7eb]': detail.class_status === 'H',
                }"
              >
                <div class="flex flex-col gap-1">
                  <p v-if="detail.sub_code">{{ detail.sub_code }}</p>
                  <p>{{ detail.class_status }}</p>
                </div>
              </td>
              <!-- <td
                class="px-6 py-3 border border-gray-200"
                :class="{
                  'bg-green-200': list.session_status2 === '(T)',
                  'bg-red-300': list.session_status2 === '(O)',
                  'bg-blue-300': list.session_status2 === 'RA',
                  'bg-[#FFFFFF]': list.session_status2 === '-',
                  'bg-[#FFFFFF]': list.session_status2 === '(F)',
                  'bg-[#FFFFFF]': list.session_status2 === '(Upcoming)',
                  'bg-green-500': list.session_status2 === '(On Going)',
                  'bg-[#e5e7eb]': list.session_status2 === '(H)',
                }"
              >
                <div class="flex flex-col gap-1">
                  <p v-if="list.session2">{{ list.session2 }}</p>
                  <p>{{ list.session_status2 }}</p>
                </div>
              </td>
              <td
                class="px-6 py-3 border border-gray-200"
                :class="{
                  'bg-green-200': list.session_status3 === '(T)',
                  'bg-red-300': list.session_status3 === '(O)',
                  'bg-blue-300': list.session_status3 === 'RA',
                  'bg-[#FFFFFF]': list.session_status3 === '-',
                  'bg-[#FFFFFF]': list.session_status3 === '(F)',
                  'bg-[#FFFFFF]': list.session_status3 === '(Upcoming)',
                  'bg-green-500': list.session_status3 === '(On Going)',
                  'bg-[#e5e7eb]': list.session_status3 === '(H)',
                }"
              >
                <div class="flex flex-col gap-1">
                  <p v-if="list.session3">{{ list.session3 }}</p>
                  <p>{{ list.session_status3 }}</p>
                </div>
              </td>
              <td
                class="px-6 py-3 border border-gray-200"
                :class="{
                  'bg-green-200': list.session_status4 === '(T)',
                  'bg-red-300': list.session_status4 === '(O)',
                  'bg-blue-300': list.session_status4 === 'RA',
                  'bg-[#FFFFFF]': list.session_status4 === '-',
                  'bg-[#FFFFFF]': list.session_status4 === '(F)',
                  'bg-[#FFFFFF]': list.session_status4 === '(Upcoming)',
                  'bg-green-500': list.session_status4 === '(On Going)',
                  'bg-[#e5e7eb]': list.session_status4 === '(H)',
                }"
              >
                <div class="flex flex-col gap-1">
                  <p v-if="list.session4">{{ list.session4 }}</p>
                  <p>{{ list.session_status4 }}</p>
                </div>
              </td>
              <td
                class="px-6 py-3 border border-gray-200"
                :class="{
                  'bg-green-200': list.session_status5 === '(T)',
                  'bg-red-300': list.session_status5 === '(O)',
                  'bg-blue-300': list.session_status5 === 'RA',
                  'bg-[#FFFFFF]': list.session_status5 === '-',
                  'bg-[#FFFFFF]': list.session_status5 === '(F)',
                  'bg-[#FFFFFF]': list.session_status5 === '(Upcoming)',
                  'bg-green-500': list.session_status5 === '(On Going)',
                  'bg-[#e5e7eb]': list.session_status5 === '(H)',
                }"
              >
                <div class="flex flex-col gap-1">
                  <p v-if="list.session5">{{ list.session5 }}</p>
                  <p>{{ list.session_status5 }}</p>
                </div>
              </td>
              <td
                class="px-6 py-3 border border-gray-200"
                :class="{
                  'bg-green-200': list.session_status6 === '(T)',
                  'bg-red-300': list.session_status6 === '(O)',
                  'bg-blue-300': list.session_status6 === 'RA',
                  'bg-[#FFFFFF]': list.session_status6 === '-',
                  'bg-[#FFFFFF]': list.session_status6 === '(F)',
                  'bg-[#FFFFFF]': list.session_status6 === '(Upcoming)',
                  'bg-green-500': list.session_status6 === '(On Going)',
                  'bg-[#e5e7eb]': list.session_status6 === '(H)',
                }"
              >
                <div class="flex flex-col gap-1">
                  <p v-if="list.session6">{{ list.session6 }}</p>
                  <p>{{ list.session_status6 }}</p>
                </div>
              </td>
              <td
                class="px-6 py-3 border border-gray-200"
                :class="{
                  'bg-green-200': list.session_status7 === '(T)',
                  'bg-red-300': list.session_status7 === '(O)',
                  'bg-blue-300': list.session_status7 === 'RA',
                  'bg-[#FFFFFF]': list.session_status7 === '-',
                  'bg-[#FFFFFF]': list.session_status7 === '(F)',
                  'bg-[#FFFFFF]': list.session_status7 === '(Upcoming)',
                  'bg-green-500': list.session_status7 === '(On Going)',
                  'bg-[#e5e7eb]': list.session_status7 === '(H)',
                }"
              >
                <div class="flex flex-col gap-1">
                  <p v-if="list.session7">{{ list.session7 }}</p>
                  <p>{{ list.session_status7 }}</p>
                </div>
              </td> -->
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="8" class="p-6 bg-[#18469d]"></td>
            </tr>
          </tfoot>
        </table>
        <div v-else class="flex justify-center">No Data Found</div>
      </div>
    </div>
  </div>
</template>

<script>

// import Header from "@/components/Instructor/Header.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import AdminHeader from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";

export default {
  data() {
    return {
      current_date: "",
      current_day: "",
      loading: true,
      HeaderComponent: null,
      // attendance_list: [
      //   {
      //     date: "10-Apr-2025",
      //     session1: "AI253",
      //     session_status1: "(O)",
      //     session2: "---",
      //     session_status2: "(F)",
      //     session3: "AI253",
      //     session_status3: "(T)",
      //     session4: "AI253",
      //     session_status4: "(On Going)",
      //     session5: "BIS613D",
      //     session_status5: "(Upcoming)",
      //     session6: "---",
      //     session_status6: "(F)",
      //     session7: "BIS613D",
      //     session_status7: "(Upcoming)",
      //   },
      //   {
      //     date: "11-Apr-2025",
      //     session1: "AI253",
      //     session_status1: "(Upcoming)",
      //     session2: "---",
      //     session_status2: "(Upcoming)",
      //     session3: "AI253",
      //     session_status3: "(Upcoming)",
      //     session4: "AI253",
      //     session_status4: "(Upcoming)",
      //     session5: "BIS613D",
      //     session_status5: "(Upcoming)",
      //     session6: "---",
      //     session_status6: "(Upcoming)",
      //     session7: "BIS613D",
      //     session_status7: "(Upcoming)",
      //   },
      //   {
      //     date: "12-Apr-2025",
      //     session1: "",
      //     session_status1: "(H)",
      //     session2: "",
      //     session_status2: "(H)",
      //     session3: "",
      //     session_status3: "(H)",
      //     session4: "",
      //     session_status4: "(H)",
      //     session5: "",
      //     session_status5: "(H)",
      //     session6: "",
      //     session_status6: "(H)",
      //     session7: "",
      //     session_status7: "(H)",
      //   },
      // ],
      attendance_list: [],
    };
  },
  
  // components: { Header },

   components: {   AdminHeader,
    HodHeader,
    CoordinateHeader,
    InstructorHeader, },

    computed: {
      ...mapGetters(["userInfo"]),
    },

  created() {

    

    this.getattendance_list();
    const today = new Date();
    this.current_date = this.formatDate(today);
    this.current_day = this.getDayName(today);
  },

  methods: {
    filterList() {},
    async getattendance_list() {
      await axios
        .get(
          `${
            process.env.VUE_APP_API_COMS
          }/faculty-admin/staff-attendance-overall-list/?Key=${localStorage.getItem(
            "LmsId"
          )}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.attendance_list = response.data.data;
            setTimeout(() => {
              this.loading = false;
            }, 600);
            console.log("this.attendance_list", this.attendance_list);
          }
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 600);
        });
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
    getDayName(date) {
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      return days[date.getDay()];
    },
  },
};
</script>

<style></style>
